import React from 'react';
import { FormattedMessage } from 'react-intl';
import VendorInfo from './VendorInfo';

export const route = {
  path: '/vendors/:slug',
  title: () => <FormattedMessage id="vendorTabs.summary" />,
  component: VendorInfo
};
